if (!customElements.get('maxcom-search')) {
  customElements.define('maxcom-search', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[name="q"]');
      this.panel = this.querySelector('.max-search-panel');
      this.list = this.querySelector('[role="listbox"]');
      this.status = this.querySelector('[role="status"]');
      this.sequence = 0;
      this.input.addEventListener('input', () => this.schedule());
      this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.schedule(); });
      this.input.addEventListener('keydown', event => this.navigate(event));
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); });
      this.outside = event => { if (!this.contains(event.target)) this.close(); };
      document.addEventListener('pointerdown', this.outside);
      this.querySelector('form').addEventListener('submit', event => { if (!this.input.value.trim()) event.preventDefault(); });
    }
    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.outside);
      clearTimeout(this.timer);
      this.controller?.abort();
      this.initialized = false;
    }
    close() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.sequence++;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.index = -1;
    }
    schedule() {
      this.close();
      const query = this.input.value.trim();
      this.list.replaceChildren();
      if (!query) return;
      const sequence = this.sequence;
      this.timer = setTimeout(() => this.search(query, sequence), 220);
    }
    async search(query, sequence) {
      this.controller = new AbortController();
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.status.textContent = this.dataset.loading;
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product,page,article');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'all');
      url.searchParams.set('section_id', 'maxcom-search-results');
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (sequence !== this.sequence) return;
        const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-max-results]');
        if (!results) throw new Error('Missing results');
        this.list.replaceChildren(results);
        this.status.textContent = '';
        this.index = -1;
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence) return;
        this.status.textContent = this.dataset.error;
      }
    }
    navigate(event) {
      if (event.key === 'Escape') { this.close(); return; }
      const options = [...this.list.querySelectorAll('[role="option"]')];
      if (this.panel.hidden || !options.length) return;
      if (event.key === 'Enter' && this.index >= 0) {
        event.preventDefault();
        options[this.index].click();
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      this.index = (this.index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.index)));
      this.input.setAttribute('aria-activedescendant', options[this.index].id);
      options[this.index].scrollIntoView({ block: 'nearest' });
    }
  });
}
